"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const DialogTitle_1 = tslib_1.__importDefault(require("@mui/material/DialogTitle"));
const DialogContent_1 = tslib_1.__importDefault(require("../DialogContent"));
class DialogErrorBoundary extends react_1.default.Component {
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { error };
    }
    constructor(props) {
        super(props);
        this.state = {
            error: null,
        };
    }
    componentDidCatch(error, errorInfo) {
        /* tslint:disable-next-line */
        console.log(error, errorInfo);
    }
    render() {
        const { DialogContentProps, DialogContentComponent, DialogTitleComponent, DialogTitleProps } = this.props;
        if (this.state.error) {
            // You can render any custom fallback UI
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(DialogTitleComponent, { ...DialogTitleProps }, "Whoops, Something went wrong"),
                react_1.default.createElement(DialogContentComponent, { ...DialogContentProps }, String(this.state.error))));
        }
        return this.props.children;
    }
}
DialogErrorBoundary.defaultProps = {
    DialogContentComponent: DialogContent_1.default,
    DialogContentProps: {},
    DialogTitleComponent: DialogTitle_1.default,
    DialogTitleProps: {},
};
exports.default = DialogErrorBoundary;
